var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import Inset from 'syf-component-library/ui/spacing/Inset';
import mediaQueries from 'syf-component-library/const/mediaQueries';
import useDeviceWidth from '../../../../../helpers/use-device-width';
import { StyledFlex } from '../../../../../styles/common';
import RefundReviewIllustration from '../../../../illustrations/refund-review-details';
import RefundReviewIllustrationMobile from '../../../../illustrations/refund-review-details/Mobile';
import { Banner, StyledDescription } from './styledcomponents';
var RefundRequestBanner = function () {
    var t = useTranslation().t;
    var isMobile = useDeviceWidth({ query: mediaQueries.lessThanMedium });
    return (_jsx(Banner, __assign({ all: "large" }, { children: _jsxs(StyledFlex, __assign({ direction: isMobile ? 'column' : 'row', justifyContent: "center", alignItems: "center" }, { children: [isMobile ? (_jsx(RefundReviewIllustrationMobile, {})) : (_jsx(RefundReviewIllustration, {})), _jsx(Inset, { all: "small" }), _jsx(StyledDescription, __assign({ size: "large", weight: "light", align: "center" }, { children: t('header.reviewRefundRequest') }))] })) })));
};
export default RefundRequestBanner;
